"use-strict";

import httpClient from "../../../http/httpClient";

const httpAuthentication = () => httpClient("/authentication", false);

export default {
  login: (credentials) => httpAuthentication().post("/logins", credentials),
};
